import { IConfig } from "./config.types";
import { envConfig } from "./envConfig";

export const prodConfig: IConfig = {
  pwa: {
    coki: {
      sameSite: "Strict",
      domain: ".flicko.online",
    },
    domain: "flicko.online",
    port: "443",
    prefixes: ["https://*.flicko.online", "https://flicko.online"],
  },
  pwaPromptDelay: 3000,
  grid: {
    resolution: 0.05,
    boundaryThreshold: 0.2,
  },
  cdn: {
    baseUrl: "https://cdn.flicko.online",
  },
  eta: {
    applicationReviewDays: 1,
  },
  app: {
    name: "CustomerFlicko",
    version: "1.0.0",
  },
  lambda: {
    baseUrl: "https://api.flicko.online",
    retry: {
      maxRetries: 3,
      initialDelayMs: 1000,
      maxDelayMs: 10000,
    },
  },
  mapsAPI: {
    nominatim: {
      baseUrl: "https://nominatim.openstreetmap.org",
    },
    photon: {
      baseUrl: "https://photon.komoot.io",
    },
  },
  otpTimer: 6,
  pages: {
    terms: "https://flicko.online/consumer-terms",
    policy: "https://flicko.online/consumer-privacy",
  },
  env: envConfig.env,
  support: {
    num: "+918999712275",
    email: "flickoapp@gmail.com",
    timing: {
      from: "11:00 AM",
      to: "11:00 PM",
    },
  },
  maps: {
    MAPBOX_TOKEN:
      "pk.eyJ1IjoiZGVlcGFrNjQ0NiIsImEiOiJjbTVhdnp4cm80aGhrMmlzZmM4am5pNXhpIn0.I3WoCX_CXKdQMG1aJSkrtg",
    MAPBOX_STYLE_URL: "mapbox://styles/mapbox/streets-v11",
    SEARCH_DEBOUNCE_DELAY: 2000,
    MIN_SEARCH_LENGTH: 5,
    DEFAULT_COORDINATES: {
      latitude: 23.2156,
      longitude: 72.6369,
    },
    ZOOM_LEVEL: 16,
    GEOCODING_BASE_URL: "https://api.mapbox.com/geocoding/v5/mapbox.places",
  },
};
